import { Card, useErrorSentryLog } from "materia"
import { useTranslation } from "react-i18next"
import s from "./NewsWidgetMobile.module.scss"

export const NewsWidgetMobileError = ({ error }: { error: unknown }) => {
  // TODO [sentry-logging] https://jira.attensi.com/browse/WEB-18745
  // Find a better place to send Sentry logs from
  useErrorSentryLog(error)
  const { t } = useTranslation()

  return (
    <Card>
      <div className={s.error}>
        <p className={s.error__text}>{t("error.NEWS_WIDGET_FETCH_ERROR")}</p>
      </div>
    </Card>
  )
}
